import React, { useState } from 'react';
import ItemsOverview from './ItemsOverview';
import WarrantyAlerts from './WarrantyAlerts';
import { useTranslation } from 'react-i18next';
import { MdInventory, MdDashboard, MdWarning } from 'react-icons/md';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const Items = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('overview');

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdInventory size={28} />}>{t('Items.title')}</PageTitle>
            </PageHeader>

            <PageContent>
                <TabBar>
                    <TabButton
                        active={activeTab === 'overview'}
                        onClick={() => setActiveTab('overview')}
                        icon={<MdDashboard />}
                    >
                        {t('Items.overview')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'warranty'}
                        onClick={() => setActiveTab('warranty')}
                        icon={<MdWarning />}
                    >
                        {t('Items.warranty_alerts')}
                    </TabButton>
                </TabBar>

                <div style={{ marginTop: '24px' }}>
                    {activeTab === 'overview' && <ItemsOverview />}
                    {activeTab === 'warranty' && <WarrantyAlerts />}
                </div>
            </PageContent>
        </PageContainer>
    );
};

export default Items;
